import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { WorkbenchAccessService } from '@coty/core/workbench-access.service'

/**
 * Keeps non-members of the workbench group from starting an agentic session
 * through a deep link, the same way the incident page hides its launcher
 * (yoshu#3565).
 *
 * For a non-member, the guard lets through any link carrying `?session=<id>`
 * (the sessions card links there to reopen a transcript). It does not check the
 * id against this incident's sessions. The backend decides who can read that
 * session, through its chat visibility rules (participant, shared chats, tenant
 * visibility flags), not through the agent's group. What the guard stops is
 * every entry that would open a new session (`?new=1`, or no parameter, which
 * resumes the newest or creates one): it sends the user back to the incident.
 */
export const workbenchGuard: CanActivateFn = (route) => {
  const access = inject(WorkbenchAccessService)
  const router = inject(Router)

  if (access.canStartWorkbench() || route.queryParamMap.get('session')) return true

  const incidentId = route.paramMap.get('incidentId')
  return router.createUrlTree(incidentId ? ['/incident', incidentId] : ['/'])
}
